import { OrderStatusDetailDisplay } from "@/configs/common";
import {booleanRenderer} from "@/views/order-query/columns";

export const initialStatus = [
  {
    display: "Toàn bộ",
    status: undefined,
    count: 0,
  },
  {
    display: "Chưa ký nhận",
    status: "NOT_SIGN",
    count: 0,
  },
  {
    display: "Đã ký nhận",
    status: "SIGN",
    count: 0,
  },
  {
    display: "Đã chuyển hoàn",
    status: "RETURNED_SIGN",
    count: 0,
  },
];

export const trackingRenderer = (
  _instance: unknown,
  td: { className: string; innerHTML: string }
): void => {
  td.className = "htMiddle";
  td.innerHTML = `<a href="javascript:void(0);" style="color:blue">Tra hành trình</a>`;
};

export const statusRenderer = (
  _instance: unknown,
  td: { className: string; innerHTML: string },
  _row: number,
  _col: number,
  _prop: string,
  value: string
): void => {
  td.className = "truncate htMiddle";
  td.innerHTML = `<a href="javascript:void(0);" style="color:blue">${OrderStatusDetailDisplay[value]}</a>`;
};

export const addressRenderer = (
  _instance: unknown,
  td: any,
  _row: number,
  _col: number,
  _prop: string,
  value: string
): void => {
  td.className = "truncate htMiddle";
  // eslint-disable-next-line no-control-regex
  td.innerHTML = value?.replace(/[\r\n\x0B\x0C\u0085\u2028\u2029]+/g, ",");
};

export const truncateRenderer = (
  _instance: unknown,
  td: { className: string; innerHTML: string },
  _row: number,
  _col: number,
  _prop: string,
  value: string
): void => {
  td.className = "truncate";
  // eslint-disable-next-line no-control-regex
  td.innerHTML = value;
};


export const columnWidths = [
  30,
  100,
  150,
  120,
  100,
  180,
  120,
  100,
  180,
  180,
  100,
  100,
  150,
  150,
  180,
  300,
  500,
  700
];

export const signColumnWidths = [
  30,
  100,
  150,
  120,
  50,
  100,
  180,
  120,
  100,
  180,
  180,
  100,
  100,
  150,
  150,
  180,
  300,
  500,
  700
];

export const columnConfigs = [
  {
    header: "",
    data: "select",
    type: "checkbox",
  },
  {
    header: "Thao tác",
    data: "billCode",
    readOnly: true,
    renderer: trackingRenderer,
  },
  {
    header: "Trạng thái",
    data: "statusDetail",
    readOnly: true,
    renderer: statusRenderer,
  },
  {
    header: "Mã vận đơn",
    data: "billCode",
    readOnly: true,
  },
  {
    header: "Mã đơn khách",
    data: "customCode",
    readOnly: true,
    renderer: truncateRenderer,
  },
  {
    header: "Người nhận",
    data: "receiverName",
    readOnly: true,
  },
  {
    header: "Điện thoại",
    data: "receiverPhone",
    readOnly: true,
  },
  {
    header: "Tiền Cod",
    data: "cod",
    type: "numeric",
    readOnly: true,
    numericFormat: {
      pattern: "0,0",
      culture: "en-US", // this is the default culture, set up for USD
    },
  },
  {
    header: "Ngày nhận kiện",
    data: "sendDate",
    readOnly: true,
  },
  {
    header: "Ngày ký nhận",
    data: "signAt",
    readOnly: true,
  },
  {
    header: "Trọng lượng",
    data: "weight",
    readOnly: true,
  },
  {
    header: "Vận phí",
    data: "freight",
    type: "numeric",
    readOnly: true,
    numericFormat: {
      pattern: "0,0",
      culture: "en-US", // this is the default culture, set up for USD
    },
  },
  {
    header: "Tên hàng hóa",
    data: "goodsName",
    readOnly: true,
  },
  {
    header: "Tỉnh/Thành Phố",
    data: "receiverProvince",
    readOnly: true,
  },
  {
    header: "Quận/Huyện",
    data: "receiverDistrict",
    readOnly: true,
  },
  {
    header: "Xã/Phường",
    data: "receiverArea",
    readOnly: true,
  },
  {
    header: "Địa chỉ",
    data: "receiverAddress",
    renderer: addressRenderer,
    readOnly: true,
  },
  {
    header: "Ghi Chú",
    data: "remark",
    readOnly: true,
  },
];

export const signColumnConfigs = [
  {
    header: "",
    data: "select",
    type: "checkbox",
  },
  {
    header: "Thao tác",
    data: "billCode",
    readOnly: true,
    renderer: trackingRenderer,
  },
  {
    header: "Trạng thái",
    data: "statusDetail",
    readOnly: true,
    renderer: statusRenderer,
  },
  {
    header: "Mã vận đơn",
    data: "billCode",
    readOnly: true,
  },
  {
    header: "GH1P",
    data: "isSignPart",
    readOnly: true,
    renderer: booleanRenderer,
  },
  {
    header: "Mã đơn khách",
    data: "customCode",
    readOnly: true,
    renderer: truncateRenderer,
  },
  {
    header: "Người nhận",
    data: "receiverName",
    readOnly: true,
  },
  {
    header: "Điện thoại",
    data: "receiverPhone",
    readOnly: true,
  },
  {
    header: "Tiền Cod",
    data: "cod",
    type: "numeric",
    readOnly: true,
    numericFormat: {
      pattern: "0,0",
      culture: "en-US", // this is the default culture, set up for USD
    },
  },
  {
    header: "Ngày nhận kiện",
    data: "sendDate",
    readOnly: true,
  },
  {
    header: "Ngày ký nhận",
    data: "signAt",
    readOnly: true,
  },
  {
    header: "Trọng lượng",
    data: "weight",
    readOnly: true,
  },
  {
    header: "Vận phí",
    data: "freight",
    type: "numeric",
    readOnly: true,
    numericFormat: {
      pattern: "0,0",
      culture: "en-US", // this is the default culture, set up for USD
    },
  },
  {
    header: "Tên hàng hóa",
    data: "goodsName",
    readOnly: true,
  },
  {
    header: "Tỉnh/Thành Phố",
    data: "receiverProvince",
    readOnly: true,
  },
  {
    header: "Quận/Huyện",
    data: "receiverDistrict",
    readOnly: true,
  },
  {
    header: "Xã/Phường",
    data: "receiverArea",
    readOnly: true,
  },
  {
    header: "Địa chỉ",
    data: "receiverAddress",
    renderer: addressRenderer,
    readOnly: true,
  },
  {
    header: "Ghi Chú",
    data: "remark",
    readOnly: true,
  },
];
